// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
ion-header.ion-no-border ion-toolbar {
  --border-width: 0;
  --border-color: transparent;
}

.env-content {
  --padding-top: 0;
  --padding-bottom: 6px;
  --padding-start: 6px;
  --padding-end: 6px;
}

/* Search sits at the top of the content (on a plain background) and stays pinned while the
 * list scrolls — a single toolbar in the header avoids the stacked-toolbar seam. */
.env-searchbar {
  position: sticky;
  top: 0;
  z-index: 5;
  padding: 8px 2px 4px;
  background: var(--ion-background-color, #ffffff);
}

ion-searchbar {
  --border-radius: 12px;
  --box-shadow: none;
  padding: 0;
}

/* Legend mapping the row icons to their meaning (room number / gateway) */
.env-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 4px 8px 2px;
  font-size: 0.72rem;
  color: var(--ion-color-medium, #8a8a8a);
}
.env-legend__item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.env-legend ion-icon {
  font-size: 13px;
}

.env-list {
  background: transparent;
  padding: 0;
}

/* Selectable environment row */
.env-item {
  --background: var(--ion-item-background, #ffffff);
  --border-radius: 12px;
  --padding-start: 16px;
  --inner-padding-end: 12px;
  --min-height: 66px;
  margin: 6px 4px;
  border-radius: 12px;
  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.1);
  transition: background 0.15s ease, border-color 0.15s ease;
}
.env-item h2 {
  font-weight: 600;
  margin-bottom: 3px;
}

.env-item--selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.1);
  border-color: rgba(var(--ion-color-primary-rgb), 0.55);
}

.env-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  color: var(--ion-color-medium, #7a7a7a);
}
.env-meta__field {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.env-meta ion-icon {
  font-size: 14px;
  flex-shrink: 0;
}
.env-meta .env-dot {
  opacity: 0.6;
}

.env-check {
  font-size: 24px;
  color: var(--ion-color-primary);
}

ion-footer.ion-no-border ion-toolbar {
  --border-width: 0;
  --border-color: transparent;
}

ion-footer ion-button[fill=solid] {
  --border-radius: 10px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/general%20components/environment-search/environment-search.component.scss","webpack://./src/components/general components/environment-search/environment-search.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,iBAAA;EACA,2BAAA;ADEF;;ACCA;EACE,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;ADEF;;ACCA;mFAAA;AAEA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,oBAAA;EACA,gDAAA;ADEF;;ACCA;EACE,qBAAA;EACA,kBAAA;EACA,UAAA;ADEF;;ACCA,0EAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,uCAAA;ADEF;ACAE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;ADEJ;ACCE;EACE,eAAA;ADCJ;;ACGA;EACE,uBAAA;EACA,UAAA;ADAF;;ACGA,+BAAA;AACA;EACE,iDAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,yDAAA;EACA,0DAAA;ADAF;ACEE;EACE,gBAAA;EACA,kBAAA;ADAJ;;ACIA;EACE,qDAAA;EACA,sDAAA;ADDF;;ACIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,uCAAA;ADDF;ACGE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;ADDJ;ACIE;EACE,eAAA;EACA,cAAA;ADFJ;ACKE;EACE,YAAA;ADHJ;;ACOA;EACE,eAAA;EACA,+BAAA;ADJF;;ACOA;EACE,iBAAA;EACA,2BAAA;ADJF;;ACOA;EACE,qBAAA;EACA,gBAAA;ADJF","sourcesContent":["@charset \"UTF-8\";\nion-header.ion-no-border ion-toolbar {\n  --border-width: 0;\n  --border-color: transparent;\n}\n\n.env-content {\n  --padding-top: 0;\n  --padding-bottom: 6px;\n  --padding-start: 6px;\n  --padding-end: 6px;\n}\n\n/* Search sits at the top of the content (on a plain background) and stays pinned while the\n * list scrolls — a single toolbar in the header avoids the stacked-toolbar seam. */\n.env-searchbar {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  padding: 8px 2px 4px;\n  background: var(--ion-background-color, #ffffff);\n}\n\nion-searchbar {\n  --border-radius: 12px;\n  --box-shadow: none;\n  padding: 0;\n}\n\n/* Legend mapping the row icons to their meaning (room number / gateway) */\n.env-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding: 4px 8px 2px;\n  font-size: 0.72rem;\n  color: var(--ion-color-medium, #8a8a8a);\n}\n.env-legend__item {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.env-legend ion-icon {\n  font-size: 13px;\n}\n\n.env-list {\n  background: transparent;\n  padding: 0;\n}\n\n/* Selectable environment row */\n.env-item {\n  --background: var(--ion-item-background, #ffffff);\n  --border-radius: 12px;\n  --padding-start: 16px;\n  --inner-padding-end: 12px;\n  --min-height: 66px;\n  margin: 6px 4px;\n  border-radius: 12px;\n  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.1);\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n.env-item h2 {\n  font-weight: 600;\n  margin-bottom: 3px;\n}\n\n.env-item--selected {\n  --background: rgba(var(--ion-color-primary-rgb), 0.1);\n  border-color: rgba(var(--ion-color-primary-rgb), 0.55);\n}\n\n.env-meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.82rem;\n  color: var(--ion-color-medium, #7a7a7a);\n}\n.env-meta__field {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.env-meta ion-icon {\n  font-size: 14px;\n  flex-shrink: 0;\n}\n.env-meta .env-dot {\n  opacity: 0.6;\n}\n\n.env-check {\n  font-size: 24px;\n  color: var(--ion-color-primary);\n}\n\nion-footer.ion-no-border ion-toolbar {\n  --border-width: 0;\n  --border-color: transparent;\n}\n\nion-footer ion-button[fill=solid] {\n  --border-radius: 10px;\n  font-weight: 600;\n}","ion-header.ion-no-border ion-toolbar {\n  --border-width: 0;\n  --border-color: transparent;\n}\n\n.env-content {\n  --padding-top: 0;\n  --padding-bottom: 6px;\n  --padding-start: 6px;\n  --padding-end: 6px;\n}\n\n/* Search sits at the top of the content (on a plain background) and stays pinned while the\n * list scrolls — a single toolbar in the header avoids the stacked-toolbar seam. */\n.env-searchbar {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  padding: 8px 2px 4px;\n  background: var(--ion-background-color, #ffffff);\n}\n\nion-searchbar {\n  --border-radius: 12px;\n  --box-shadow: none;\n  padding: 0;\n}\n\n/* Legend mapping the row icons to their meaning (room number / gateway) */\n.env-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding: 4px 8px 2px;\n  font-size: 0.72rem;\n  color: var(--ion-color-medium, #8a8a8a);\n\n  &__item {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  ion-icon {\n    font-size: 13px;\n  }\n}\n\n.env-list {\n  background: transparent;\n  padding: 0;\n}\n\n/* Selectable environment row */\n.env-item {\n  --background: var(--ion-item-background, #ffffff);\n  --border-radius: 12px;\n  --padding-start: 16px;\n  --inner-padding-end: 12px;\n  --min-height: 66px;\n  margin: 6px 4px;\n  border-radius: 12px;\n  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.1);\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  h2 {\n    font-weight: 600;\n    margin-bottom: 3px;\n  }\n}\n\n.env-item--selected {\n  --background: rgba(var(--ion-color-primary-rgb), 0.1);\n  border-color: rgba(var(--ion-color-primary-rgb), 0.55);\n}\n\n.env-meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.82rem;\n  color: var(--ion-color-medium, #7a7a7a);\n\n  &__field {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  ion-icon {\n    font-size: 14px;\n    flex-shrink: 0;\n  }\n\n  .env-dot {\n    opacity: 0.6;\n  }\n}\n\n.env-check {\n  font-size: 24px;\n  color: var(--ion-color-primary);\n}\n\nion-footer.ion-no-border ion-toolbar {\n  --border-width: 0;\n  --border-color: transparent;\n}\n\nion-footer ion-button[fill=\"solid\"] {\n  --border-radius: 10px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
